<style scoped>
.profile-info {
  background: #fff;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 15px;
  padding-top: 15px;
}
.profile-info > .upload-avatar {
  width: 100%;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  display: flex;
}

.upload-avatar {
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.set-location {
  display: flex;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;
  padding-bottom: 15px;
}

.upload-avatar > button,
.set-location > button {
  width: 100%;
}

.custom-ui-select {
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-left: 4px;
  padding-right: 24px;
  display: inline-block;
  width: 199px;
  color: #495060;
}

.upload-avatar > button:first-child{
  margin-right: 15px;
}

.set-location > .work-location {
  margin-right: 15px;
}

.others > .label {
  font-size: 1em;
}
.others {
  border-top: 1px solid #eee;
  margin-top: 20px;
  padding-top: 15px;
  display: flex;
  justify-content: space-between;
}
.action-buttons {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #eee;
  margin-top: 20px;
  padding-top: 15px;
}

.horizontal-line{
  width: 100%;
  /* border-bottom: 1px solid #eee; */
  margin-top: 25px;
}
</style>

<template>
   <div class="profile-info" v-if="load_profile_fields">
      <!-- <div class="upload-avatar">
        <Button icon="camera" v-on:click="uploadImage" :loading="imageUploadLoader || avatarLoader" class="change-avatar">Change Avatar</Button>

        <Button v-if="!workLocation" icon="android-pin" v-on:click="changeRoute('set-location?type=work&readonly=false')" class="work-location">Set Location</Button>
        <Button v-if="workLocation" icon="android-pin" v-on:click="changeRoute('set-location?type=work&readonly=true')" class="work-location">View Location</Button>
      </div>
      <div class="set-location" v-if="false">
        <Button v-if="!workLocation" icon="android-pin" v-on:click="changeRoute('set-location?type=work&readonly=false')" class="work-location">Set work Location</Button>
        <Button v-if="workLocation" icon="android-pin" v-on:click="changeRoute('set-location?type=work&readonly=true')" class="work-location">View Location</Button>

        <Button v-if="!homeLocation" icon="android-pin" v-on:click="changeRoute('set-location?type=home&readonly=false')">Set home Location</Button>
        <Button v-if="homeLocation" icon="android-pin" v-on:click="changeRoute('set-location?type=home&readonly=true')">View home Location</Button>
      </div> -->
      <div class="profile-info__main">
        <NotificationSW></NotificationSW>
        <!-- <div v-if="!triggeredFields['display_name'] && !profileInfo['display_name']">
          <Alert v-if="triggeredFields.display_name == ''" show-icon>Display name should not be empty.</Alert>
        </div> -->

        <!-- <div v-if="triggeredFields.display_name || profileInfo['display_name']">
          <Alert v-if="triggeredFields.display_name == ''" show-icon>Display name should not be empty.</Alert>
          <div v-if="triggeredFields.display_name == '' || !triggeredFields.display_name">
            <b v-if="profileInfo['display_name'] != '' && triggeredFields.display_name != ''" style="text-align: center; display: block">"{{profileInfo['display_name']}}"</b>
          </div>
          <div v-if="triggeredFields.display_name">
            <b v-if="triggeredFields.display_name != ''" style="text-align: center; display: block">"{{triggeredFields.display_name}}"</b>
          </div>
        </div> -->
        <div>
          <ProfileInfoFileds :type="'string'"
               :field-value="profileInfo['display_name']"
               :label="'Display Name'"
               :slug="'display_name'"
               v-on:saveData="onSave"></ProfileInfoFileds>
        </div>
        <div v-for="(field, indx) in profileFields" :key="indx">
          <div v-if="field.slug !== 'address' && field.slug !== 'address'
            && field.slug !== 'interest' && field.slug !== 'province'
            && field.slug !== 'region' && field.slug !== 'contact_number'
            && field.slug !== 'type_supported' && field.slug !== 'reason'
            && field.slug !== 'country' && field.slug !== 'notable'
            && field.slug !== 'accomplishment' && field.slug !== 'education'">
            <ProfileInfoFileds v-if="field.type === 'enum'"
               :type="field.type"
               :field-selections="field.options"
               :field-value="profileInfo[field.slug]"
               :label="field.label"
               :slug="field.slug"
               v-on:saveData="onSave"></ProfileInfoFileds>
            <ProfileInfoFileds v-else-if="field.type === 'array'"
                :type="field.type"
                :field-selections="field.options"
                :field-value="profileInfo[field.slug]"
                :label="field.label"
                :slug="field.slug"
                :is-multiple="true"
                v-on:saveData="onSave"></ProfileInfoFileds>
            <ProfileInfoFileds v-else
                :type="field.type"
                :field-value="profileInfo[field.slug]"
                :label="field.label"
                :slug="field.slug"
                v-on:saveData="onSave"></ProfileInfoFileds>
          </div>
          <div v-if="field.slug == 'province' && provinceList.length > 0">
            <ProfileInfoFileds
               :type="'province'"
               :field-selections="provinceList"
               :field-value="profileInfo[field.slug]"
               :label="field.label"
               :slug="field.slug"
               v-on:saveData="onSave"></ProfileInfoFileds>
          </div>
          <div v-if="field.slug == 'region'">
            <ProfileInfoFileds
               :type="'region'"
               :field-selections="regionlist"
               :field-value="profileInfo[field.slug]"
               :label="field.label"
               :slug="field.slug"
               v-on:saveData="onSave"></ProfileInfoFileds>
          </div>
          <div v-if="field.slug == 'country'">
            <ProfileInfoFileds
               :type="'country'"
               :field-selections="sortedCountries"
               :field-value="profileInfo[field.slug]"
               :label="field.label"
               :slug="field.slug"
               v-on:saveData="onSave"></ProfileInfoFileds>
          </div>
          <div v-if="field.slug == 'contact_number'">
            <ProfileInfoFileds :type="'phone'"
               :field-value="profileInfo[field.slug]"
               :label="field.label"
               :slug="field.slug"
               v-on:saveData="onSave"></ProfileInfoFileds>
          </div>
          <div v-if="field.slug == 'reason'">
            <ProfileInfoFileds :type="'textarea'"
               :field-value="profileInfo[field.slug]"
               :label="field.label"
               :slug="field.slug"
               v-on:saveData="onSave"></ProfileInfoFileds>
          </div>

          <div v-if="field.slug == 'last_name'" class="horizontal-line">
          </div>

        </div>
        <!-- <br/>
        <div>
          <span style="width:145px;display:inline-block;vertical-align: top;line-height: 30px;">Region</span>
          <select v-model="profileInfo.region" class="ivu-select-selection custom-ui-select">
            <option v-for="item in sortedRegions" :key="item" @click="profileInfo.region = item.name">{{ item.name }}</option>
          </select>
        </div><br/>
        <div>
          <span style="width:145px;display:inline-block;vertical-align: top;line-height: 30px;">Province</span>
          <select v-model="profileInfo['province']" class="ivu-select-selection custom-ui-select">
            <option v-for="item in provinces" :key="item" v-if="profileInfo.region == getRegionKey.key" @click="profileInfo.province = item.name">{{ item.name }}</option>
          </select>
        </div>-->
      </div>
      <!-- <div class="action-buttons">
         <Button type="primary" v-on:click="updateUserInfo"
            :disabled="disableSaveButton" :loading="updateLoader">Save</Button>
      </div> -->
      <UploadImageComponent ref="uploadImage" @emitBase64="onLoadImage"></UploadImageComponent>
   </div>
</template>

<script>
import ProfileInfoFileds from "@/components/ProfileInfoFields";
import UploadImageComponent from "@/components/UploadImageComponent";
import NotificationSW from "@/components/PushNotificationEnabler";
import _ from "lodash";
import provinces from '@/helpers/ph-info/provinces.json'
import regions from '@/helpers/ph-info/regions.json'
import relations2Json from '@/assets/refregion_detailed.json'
import axios from 'axios'
import countries from '@/assets/countries.json'

import { TelInput } from '@/helpers/tel-input';

export default {
  name: "ProfileInfoComponent",
  components: {
    ProfileInfoFileds,
    UploadImageComponent,
    TelInput,
    NotificationSW
  },
  data() {
    return {
      profile_primary_fields: {
        status: "",
        alert_network: "",
        display_name: "",
        about_me: "",
        country: "",
        region: ""
      },
      image: {
        changed: false,
        oldImage: '',
        newImage: '',
      },
      load_profile_fields: false,
      currentMeta: this.$route.meta,
      triggeredFields: {},
      disableSaveButton: true,
      regionlist: [],
      provinceList: [],
    };
  },
  watch: {
    profileFields: function(val) {
      this.initProfilePrimaryFields();
    }
  },
  mounted() {
    this.initProfilePrimaryFields();
    this.regionlist = regions
    if(this.profileInfo.province){
      this.getProvince(this.profileInfo.region)
    }
  },
  computed: {
    // sortedRegions() {
    //   return this.regionlist.sort(function (a, b) {
    //     return ('' + a.name).localeCompare(b.name);
    //   })
    // },
    sortedCountries() {
      return countries.sort(function (a, b) {
        return ('' + a.name).localeCompare(b.name);
      })
    },
    sortedProvinces() {
      return this.provinces.sort(function (a, b) {
         return ('' + a.name).localeCompare(b.name);
      })
    },
    profileInfo() {
      return this.$store.state.user.info;
    },
    profileFields() {
      if (this.$store.state.user.userFields.length !== undefined) {
        let fields = _.cloneDeep(this.$store.state.user.userFields);

        let cityIndex = fields.findIndex(o => o.slug === 'city')
        let provinceIndex = fields.findIndex(o => o.slug === 'province')

        let c = fields[cityIndex]
        fields[cityIndex] = fields[provinceIndex]
        fields[provinceIndex] = c

        fields = this.swapElement(fields, 6, 4)
        fields = this.swapElement(fields, 9, 14)
        // console.log(fields)
        fields = this.swapElement(fields, 11, 14)

        return fields;
      }

      return [];
    },
    updateLoader() {
      return this.$store.state.user.isLoadingUserProfile;
    },
    postImageFile: {
      get() {
        return this.$store.state.publicModule.uploadedImage;
      }
    },
    imageUploadLoader: {
      get() {
        return this.$store.state.publicModule.imageUploadLoader;
      }
    },
    avatarLoader: {
      get() {
        return this.$store.state.user.isLoadingUserAvatar;
      }
    },
    workLocation: {
      get() {
        return _.get(this.$store.state.user, "info.places.work");
      }
    },
    homeLocation: {
      get() {
        return _.get(this.$store.state.user, "info.places.home");
      }
    }
  },
  beforeDestroy() {
    if (this.image.changed) {
      // image was changed and was not save, revert back to old image
      console.log('revert image')
      this.$store.commit("user/updateUserAvatar", this.image.oldImage)
    }
  },
  methods: {
    getRegionKey() {
      return searchArrayValue(this.form.region, this.regions)
    },
    initProfilePrimaryFields() {
      this.profile_primary_fields.status = this.getBySlug("other", "status");
      this.profile_primary_fields.alert_network = this.getBySlug(
        "other",
        "alert_network"
      );
      this.profile_primary_fields.display_name = this.getBySlug(
        "account",
        "display_name"
      );
      this.profile_primary_fields.about_me = this.getBySlug(
        "profile_info",
        "about_me"
      );
      this.profile_primary_fields.country = this.getBySlug(
        "overseas_info",
        "country"
      );
      this.profile_primary_fields.region = this.getBySlug(
        "philippine_info",
        "region"
      );
      this.load_profile_fields = true;
    },

    getBySlug(groupSlug, slug) {
      let r = this.profileFields.find(
        profileField => profileField.group_slug === groupSlug
      );

      if (r) {
        let s = r.fields.find(field => field.slug === slug);
        s["group_slug"] = r.group_slug;
        return !slug ? r : s;
      }
    },

    swapElement(array, from, to) {
      // let tmp = array[indexA]
      // array[indexA] = array[indexB]
      // array[indexB] = tmp

      // let tmp = array.splice(1,1);
      // array.splice(2,0,tmp);

      array.splice(to, 0, array.splice(from, 1)[0]);

      return array
    },

    onSave(data) {
      console.log(data)
      this.$emit('onSaveData', data);
      //get the group_slug
      // let group_slug = this.profile_primary_fields[data.slug].group_slug;

      //set profile info value
      // this.profileInfo[group_slug][data.slug] = data.value;
      //  = data.value;
      this.$set(this.triggeredFields, [data.slug], data.value)
      console.log(this.triggeredFields.display_name)
      // if (group_slug == "account") {
      //   this.triggeredFields[data.slug] = data.value;
      // }
      if(data.slug == 'display_name'){
        if(data.value == ''){
          this.disableSaveButton = true;
          return false
        }
      }
      this.disableSaveButton = false;
      if(data.slug == 'region' && data.value){
        this.getProvince(data.value)
      }
    },

    updateUserInfo() {

      if (this.image.changed) {
        let image = this.image.newImage;
        this.$store
        .dispatch("publicModule/uploadBase64Image", { base64_image: image })
        .then(res => {
          if (!_.isEmpty(this.postImageFile))
            this.$store
              .dispatch("user/updateUserAvatar", {
                avatar: this.postImageFile.uploaded[0]
              })
              .then(res => {
                this.image.changed = false
                this.$store.commit("user/updateUserAvatar", image);
              });
        });
      }

      let val = {
        id: this.profileInfo.id,
        data: this.triggeredFields
      };
      this.$store.dispatch("user/updateUserInfo", val).then(response => {
        this.disableSaveButton = true;
        this.$Message({
          closable: true,
          // durationInSec:3,
          title: { content:'Updated' },
          icon: 'checkmark',
          message: { content: 'Profile Info updated.' },
          buttons: [
            { label: 'Ok', type: 'primary', hideAfter:true, action: ()=> next() }
          ]
        });            
      });

    },

    uploadImage() {
      this.$refs.uploadImage.triggerUpload();
    },

    onLoadImage(image) {
      console.log(image)
      if (!this.image.changed) {
        // we will back up the original image when user selects a new image
        this.image.oldImage = this.$store.state.user.info.avatar
      }

      this.$emit('imageChanged', image)

      this.image.changed = true
      this.image.newImage = image[0]
      this.disableSaveButton = false
      this.$store.commit("user/updateUserAvatar", image[0])
    },

    checkIfEmptyField(field, slug) {
      return field ? field[slug] : "";
    },

    changeRoute(url) {
      this.$router.push({ path: url });
    },

    getProvince(region){
      let regKey = null
      this.provinceList = []

      for (let i = 0; i < this.regionlist.length; i++){
        if (this.regionlist[i].name == region){
          regKey = this.regionlist[i].key
        }
      }

      for (let i = 0; i < provinces.length; i++){
        if(provinces[i].region == regKey){
          this.provinceList.push(provinces[i])
        }
      }
    }
  }
};
</script>
